<template>
    <v-container>
        <div class="page-header">
            Мои авто
        </div>
        <AppCarList :cars="cars"/>

        <!-- <v-row>
            <v-col cols="12" md="4">
                <v-btn class="add-car-btn" elevation="0" @click="createCar()">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right:6px;">
                        <g clip-path="url(#clip0_517_3834)">
                            <path d="M8.0013 15.3333V0.666626M0.667969 7.99996H15.3346" stroke="#DA251C" stroke-width="1.8"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_517_3834">
                                <rect width="16" height="16" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>

                    Добавить автомобиль
                </v-btn>
            </v-col>
        </v-row> -->
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'

    import AppCarList from '@/components/app/personal/garage/CarList'

    export default {
        name: 'GarageScreen',

        components: {
            AppCarList,
        },

        computed: {
            ...mapGetters({
                cars: 'car/getCars',
            }),
        },

        mounted() {
            this.$store.dispatch('car/fetch')
            this.$store.dispatch('carHistory/fetch')
        },

        methods: {
            createCar() {
                this.$router.push({
                    name: 'GarageCarEdit',
                })
            },
        },
    }
</script>

<style>
    .page-header {
        color: #36393B;
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%;
    }
    .mobile .page-header {
        font-size: 20px;
        font-weight: 600;
    }
    .add-car-btn {
        display: flex;
        width: 384px;
        height: 138px !important;
        padding: 16px 40px !important;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 12px;
        border: 1.5px solid #DA251C;
        background: #FFF !important;
        color: #DA251C !important;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .mobile .add-car-btn {
        display: flex;
        width: 100%;
        height: 80px !important;
        border-radius: 6px !important;
    }
</style>
